import React, { FC, Fragment } from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames, ChangeTypes } from "../../clients/FirebaseClient/types";
import { InfoBoxFutureProof } from "../core/InfoBox";

const convertValue = (
    value: ChangeTypes[ChangeNames.NEW_CONNECTION_MULTILINE_DESIRES]["value"],
): string => {
    if (value.yes) {
        return "yes";
    } else if (value.no) {
        return "no";
    } else if (value.thirdParty) {
        return "thirdParty";
    }
    return "";
};

export const NewConnectionMultilineDesiresForm: FC = () => {
    const classes = useStyles();

    const { values, setValues, submitChange } = useFormModel<
        | ChangeNames.NEW_CONNECTION_MULTILINE_DESIRES
        | ChangeNames.NEW_CONNECTION_BUILDING_TYPES
        | ChangeNames.NEW_CONNECTION_CELLAR
        | ChangeNames.NEW_CONNECTION_BUILDING_INTAKES
    >();

    const selection = convertValue(values.newConnectionMultilineDesires.value);

    return (
        <Fragment>
            <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                Mehrspartenhausanschluss von der Syna gewünscht?
            </h4>
            <FormControl component="fieldset" style={{ display: "flex" }}>
                <RadioGroup
                    value={selection}
                    onChange={(e, v) => {
                        const newValues = setValues(values => {
                            values.newConnectionMultilineDesires.value.yes = v.indexOf("yes") >= 0;
                            values.newConnectionMultilineDesires.value.no = v.indexOf("no") >= 0;
                            values.newConnectionMultilineDesires.value.thirdParty =
                                v.indexOf("thirdParty") >= 0;
                        });
                        submitChange(newValues);
                    }}
                >
                    <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Ja"
                        error={values.newConnectionMultilineDesires.error !== null}
                    />
                    <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="Nein"
                        error={values.newConnectionMultilineDesires.error !== null}
                    />
                    <FormControlLabel
                        value="thirdParty"
                        control={<Radio />}
                        label="Die Mehrspartenhauseinführung wird durch einen anderen Anbieter ausgeführt"
                        error={values.newConnectionMultilineDesires.error !== null}
                    />
                </RadioGroup>
                {values.newConnectionMultilineDesires.value.no &&
                    !values.newConnectionBuildingTypes.value.existing && <InfoBoxFutureProof />}
            </FormControl>
        </Fragment>
    );
};
